module.exports = __webpack_public_path__ + "static/img/banner12.75c56137.png";